let initialState = {
  data: {},
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CUSTOMER_DATA":
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default customerReducer;
